import React from 'react';

import moment from 'moment';
import _ from 'lodash';
import 'moment/locale/es';
import { DatePicker, Input, Tooltip, Select, Button, Radio, Form } from 'antd';
import * as Icons from '@ant-design/icons';
import { useQuery } from '@apollo/react-hooks';
import Avatar from '../../common/Avatar';

import getCiudades from '../../../graphql/querys/organismos/getCiudades.graphql';
import Loading from '../../common/Loading';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const Option = Select.Option;

moment.locale();

const NIVEL_ESTUDIO = [
  'SIN ESTUDIOS',
  'PRIMARIO INCOMPLETO',
  'PRIMARIO COMPLETO',
  'SECUNDARIO INCOMPLETO',
  'SECUNDARIO COMPLETO',
  'TERCIARIO INCOMPLETO',
  'TERCIARIO COMPLETO',
  'UNIVERSITARIO INCOMPLETO',
  'UNIVERSITARIO COMPLETO',
];

const NACIONALIDADES = [
  'ARGENTINA',
  'CHILENA',
  'BOLIVIANA',
  'BRASILEÑA',
  'COLOMBIANA',
  'PERUANA',
  'PARAGUAYA',
  'URUGUAYA',
  'VENEZOLANA',
  'OTRA',
];

const ESTADOS_CIVILES = ['SOLTERO/A', 'CASADO/A', 'VIUDO/A', 'DIVORCIADO/A'];

const FormPersona = props => {
  const [form] = Form.useForm();

  const queryCiudades = useQuery(getCiudades, {
    fetchPolicy: 'network-only',
  });

  // eslint-disable-next-line no-unused-vars
  const onFinishFailed = ({ errorFields }) => {
    form.scrollToField(errorFields[0].name);
  };

  const onFinish = values => {
    if (values.fecha_nacimiento) {
      let fecha = values.fecha_nacimiento.toDate();
      values.fecha_nacimiento = fecha;
    }

    if (values.nombre) {
      values.nombre = values.nombre.toUpperCase();
    }

    if (values.apellido) {
      values.apellido = values.apellido.toUpperCase();
    }
    if (props.requiereDNI != undefined && props.requiereDNI == false) {
      // console.log('ENTRE A REPLANZAR DATOS');
      values.tipo_doc = values.tipo_doc ? values.tipo_doc : null;
      values.num_doc = values.num_doc ? values.num_doc : null;
    }
    if (values.num_doc && !values.tipo_doc) {
      form.setFields([
        {
          name: 'tipo_doc',
          errors: ['Por favor, selecciona el tipo de documento'],
        },
      ]);
      return;
    }
    props.onSubmit(values);
  };

  const checkNumDoc = (rule, value, callback) => {
    // console.log("Entre a chequear el numero");
    if (props.requiereDNI != undefined && props.requiereDNI == false) {
      //ESTE IF INDICA, QUE EN CASO DE QUE NO SE REQUIERA DNI, no haga la comprobacion de puntos
      callback();
    }
    var bool = /^[0-9]*$/.test(value);
    if (bool) {
      callback();
    } else {
      callback('El numero de documento es unicamente con numeros, sin puntos');
    }
  };

  const crearOpciones = ciudad => {
    return (
      <Option key={ciudad._id} value={ciudad._id}>
        {ciudad.nombre}
      </Option>
    );
  };

  const requerido = props.requiereDNI != undefined ? props.requiereDNI : true;

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  if (queryCiudades.loading) {
    return <Loading />;
  }

  let listaCiudades = queryCiudades.data.getCiudades;
  if (listaCiudades) {
    var opciones = _.map(listaCiudades, crearOpciones);
  }

  // console.log("··················· DESPUES DEL IF");

  // console.log('ES REQUERIDO!??????? ####: ', props);
  // console.log(requerido);
  const prefixDocumento = (
    <Form.Item
      name="tipo_doc"
      noStyle
      rules={[
        {
          required: requerido,
          message: 'Por favor, ingresar el tipo de documento!',
        },
      ]}
    >
      <Select style={{ width: 70 }}>
        <Option value="DNI">DNI</Option>
        <Option value="CI">CI</Option>
        <Option value="LC">LC</Option>
        <Option value="LE">LE</Option>
      </Select>
    </Form.Item>
  );


  const generoSelector = (
    <Form.Item
      name="genero"
      noStyle
    >
    <Select placeholder ="Genero" style={{ width: 150 }}>
      <Option value="F">F - Femenino</Option>
      <Option value="M">M - Masculino</Option>
      <Option value="X">X - No Binario</Option>
    </Select>
    </Form.Item>
  );

  return (
    <div>
      {props.persona._id ? (
        <Avatar idPersona={props.persona._id} />
      ) : (
        <Avatar />
      )}
      <Form
        onFinish={onFinish}
        className="formularios"
        form={form}
        initialValues={{
          tipo_doc: props.persona ? props.persona.tipo_doc : 'DNI',
          num_doc: props.persona ? props.persona.num_doc : '',
          nombre: props.persona ? props.persona.nombre : '',
          apellido: props.persona ? props.persona.apellido : '',
          fecha_nacimiento: props.persona.fecha_nacimiento
            ? moment(moment(props.persona.fecha_nacimiento), 'DD/MM/YYYY')
            : props.persona.fecha_nacimiento === 0 ||
              (props.requiereDNI != undefined && props.requiereDNI == false)
            ? null
            : moment(),
          sexo:
            props.persona &&
            props.persona.sexo !== 'Masculino' &&
              props.persona.sexo !== 'Femenino'
              ? 'X'
              : props.persona.sexo,
          profesion: props.persona ? props.persona.profesion : '',
          nacionalidad: props.persona ? props.persona.nacionalidad : '',
          estado_civil: props.persona ? props.persona.estado_civil : '',
          telefono: props.persona ? props.persona.telefono : '',
          direccion_calle: props.persona ? props.persona.direccion_calle : '',
          direccion_numero: props.persona ? props.persona.direccion_numero : '',
          direccion_otro: props.persona ? props.persona.direccion_otro : '',
          educacion: props.persona ? props.persona.educacion : '',
          localidad:
            props.persona && props.persona.localidad
              ? props.persona.localidad._id
              : '',
        }}
      >
        <FormItem
          {...formItemLayout}
          name="num_doc"
          label={
            <span>
              Documento
              <Tooltip title="Tipo y Numero de documento">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: requerido,
              message:
                'Por favor, ingresar el documento de forma correcta, sin puntos!',
              validator: checkNumDoc,
            },
          ]}
        >
          <Input addonBefore={prefixDocumento} addonAfter={generoSelector} style={{ width: 500 }} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="nombre"
          label={
            <span>
              Nombre
              <Tooltip title="Nombre de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: true,
              message: 'Por favor, ingresar el nombre!',
              whitespace: true,
            },
          ]}
        >
          <Input style={{ width: 500 }} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="apellido"
          label={
            <span>
              Apellido
              <Tooltip title="Apellido de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: true,
              message: 'Por favor, ingresar el apellido!',
              whitespace: true,
            },
          ]}
        >
          <Input style={{ width: 500 }} />
        </FormItem>

        <FormItem
          name="fecha_nacimiento"
          {...formItemLayout}
          label={
            <span>
              Fecha Nacimiento
              <Tooltip title="Seleccione la fecha de nacimiento de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: false,
              message: 'Por favor, seleccione la fecha de nacimiento',
            },
          ]}
        >
          <DatePicker style={{ width: 500 }} format="DD/MM/YYYY" />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="sexo"
          label={
            <span>
              Sexo
              <Tooltip title="Sexo de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: true,
              message: 'Por favor, ingresar el sexo!',
              whitespace: true,
            },
          ]}
        >
          <RadioGroup style={{ width: 500 }}>
            <Radio value="Masculino">Masculino</Radio>
            <Radio value="Femenino">Femenino</Radio>
            <Radio value="X">X</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="profesion"
          label={
            <span>
              Ocupacion/Profesion
              <Tooltip title="Profesion de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              message: 'Por favor, ingresar la ocupacion/profesion!',
              whitespace: true,
            },
          ]}
        >
          <Input style={{ width: 500 }} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="educacion"
          label={
            <span>
              Educacion
              <Tooltip title="Nivel de educacion de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              message: 'Por favor, ingresar el nivel de educacion!',
              whitespace: true,
            },
          ]}
        >
          <Select
            showSearch
            style={{ width: 500 }}
            placeholder="Seleccione un nivel de estudios"
            optionFilterProp="children"
            onChange={props.handleChange}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {_.map(NIVEL_ESTUDIO, nivel => {
              return (
                <Option key={nivel} value={nivel}>
                  {nivel}
                </Option>
              );
            })}
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="nacionalidad"
          label={
            <span>
              Nacionalidad
              <Tooltip title="Lugar de nacimiento de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: requerido,
              message: 'Por favor, ingresar la nacionalidad!',
              whitespace: true,
            },
          ]}
        >
          <Select
            showSearch
            style={{ width: 500 }}
            placeholder="Seleccione una nacionalidad"
            optionFilterProp="children"
            onChange={props.handleChange}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {_.map(NACIONALIDADES, nacionalidad => {
              return (
                <Option key={nacionalidad} value={nacionalidad}>
                  {nacionalidad}
                </Option>
              );
            })}
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="estado_civil"
          label={
            <span>
              Estado Civil
              <Tooltip title="El estado civil de las personas">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              required: requerido,
              message: 'Por favor, ingresar el estado civil!',
              whitespace: true,
            },
          ]}
        >
          <Select
            showSearch
            style={{ width: 500 }}
            placeholder="Seleccione un estado civil"
            optionFilterProp="children"
            onChange={props.handleChange}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {_.map(ESTADOS_CIVILES, estadoCivil => {
              return (
                <Option key={estadoCivil} value={estadoCivil}>
                  {estadoCivil}
                </Option>
              );
            })}
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="telefono"
          label={
            <span>
              Telefono
              <Tooltip title="El telefono de la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              message: 'Por favor, ingrese el telefono!',
              whitespace: false,
            },
          ]}
        >
          <Input style={{ width: 500 }} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="localidad"
          label={
            <span>
              Localidad
              <Tooltip title="Localidad donde esta radicado actualmente">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              message: 'Por favor, ingresar la localidad!',
              whitespace: true,
            },
          ]}
        >
          <Select
            showSearch
            style={{ width: 500 }}
            placeholder="Seleccione una localidad"
            optionFilterProp="children"
            onChange={props.handleChange}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {opciones}
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="direccion_calle"
          label={
            <span>
              Calle - Direccion
              <Tooltip title="Calle actual donde vive la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              message: 'Por favor, ingresar la calle!',
              whitespace: true,
            },
          ]}
        >
          <Input style={{ width: 500 }} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="direccion_numero"
          label={
            <span>
              Numero - Direccion
              <Tooltip title="Numero del domicilio actual donde vive la persona">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              message: 'Por favor, ingresar el numero!',
              whitespace: true,
            },
          ]}
        >
          <Input style={{ width: 500 }} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          name="direccion_otro"
          label={
            <span>
              Obs. Direccion
              <Tooltip title="Observacion extra de la actual direccion">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
          rules={[
            {
              message: 'Por favor, ingresar la direccion!',
              whitespace: true,
            },
          ]}
        >
          <Input style={{ width: 500 }} />
        </FormItem>

        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Confirmar
          </Button>
          <Button type="danger" onClick={() => props.onAnterior()}>
            Cancelar
          </Button>
        </FormItem>
      </Form>
    </div>
  );
};

export default FormPersona;
